import React from 'react';
import i18n from 'src/utils/translate';
import styled, { css } from 'styled-components';
import * as log from 'loglevel';
import { getCurrentRoute } from 'src/utils/router';

import SitebarDropdown from './sitebarDropdown';
import Badge from 'src/components/badges/badge';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';

import api from 'src/utils/api';
import config from 'config/config';
import { getCommunityLogoUrl } from 'src/utils/linkUtils';
import InformationCard from 'src/components/informationCard';
import { getDiscoverLinks } from 'src/modules/home/components/discoverSection';
import { text, textLight, textLinkSecondary } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';
import Avatar from '../avatar';

const PROGRAM_URL = config.cdn.programsIndex;

const getFixedHeight = (communityCount, programsCount) => {
  if ((programsCount + communityCount >= 8) || programsCount === 0) return 530;
  // add back in === 0 and remove from above when scrollbar is always visible on dropdown
  // else if (programsCount === 0) {
  //   return (((programsList.length + communityCount + 1) * 43) + 200);
  else return 140 + ((communityCount + programsCount) * 43);
};

const SuggestedProgramLink = ({ program }) => {
  const { name, id, params } = program;
  const href = `/${id}${params ? params : ''}`;
  const code = id.replace('programs/', '');
  return (
    <li>
      <SuggestedProgramLinkItem href={href} onClick={() => {
        trackFootfallEvent(Event.CLICKED, { clickMetadata: {section: Section.Program, element: name}, clickType: 'hub-menu' });
      }}>
        <Avatar alt={`${name} image`} size="xsmall" src={`${PROGRAM_URL}${code}.png`} />
        { name }
      </SuggestedProgramLinkItem>
    </li>
  );
};

const ProgramsEmptyState = () => {
  const programs = getDiscoverLinks().find(link => link.id === 'programs').links;
  return (
    <div>
      <ProgramEmptyStateSubtitle>{i18n.t("Looks like you're not enrolled in any programs yet!")}</ProgramEmptyStateSubtitle>
      <InformationCard>
        <ProgramEmptyStateText>{i18n.t('Browse programs')}</ProgramEmptyStateText>
        <SuggestedProgramList>
          { programs.map(program => <SuggestedProgramLink key={program.id} program={program} />) }
        </SuggestedProgramList>
      </InformationCard>
    </div>
  );
};


export default class HubMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAllCommunities: false, showAllPrograms: false, programs: [] };
  }

  componentDidMount() {
    this.fetchPrograms();
  }

  fetchPrograms = async () => {
    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type 'Readonly... Remove this comment to see the full error message
      const { data } = await api.get(`private/programs/subscribed?user-id=${this.props.userId}`);
      this.setState({ programs: data });
    } catch (ex) {
      log.error(ex);
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClick' does not exist on type 'Rea... Remove this comment to see the full error message
    const { handleClick, open, followedCommunities } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAllCommunities' does not exist on ty... Remove this comment to see the full error message
    const { showAllCommunities, showAllPrograms, programs } = this.state;
    const sortedCommunities = followedCommunities.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    const COMMUNITIES_TO_SHOW = 5;
    const filteredCommunities = showAllCommunities ? sortedCommunities : sortedCommunities.slice(0, COMMUNITIES_TO_SHOW);
    const filteredPrograms = showAllPrograms ? programs : programs.slice(0, 3);

    return (
      <Container>
        <HubMenuButton
          isActive={open || getCurrentRoute() === '/myHub'}
          onClick={handleClick}
        >
          <Icon className="icon-communities" />
          {i18n.t('My hub')}
        </HubMenuButton>
        <SitebarDropdown fixedHeight={getFixedHeight(filteredCommunities.length, filteredPrograms.length)} open={open}>
          <div className="divider">
            {i18n.t('Communities')}
          </div>
          <ul data-test-id="hub-menu-community-list">
            {filteredCommunities.map(({slug, logoImageHash, name}) => (
              <li key={slug}>
                <a href={`/${slug}`}>
                  <Avatar alt={`${name} image`} size="xsmall" src={getCommunityLogoUrl(logoImageHash, true)} />
                  {name}
                </a>
              </li>
            ))}
            {((!showAllCommunities && followedCommunities.length <= 3) || showAllCommunities) && (
              <li>
                <a
                  className="hub-menu__browse-communities__link"
                  href={'/search/communities'}
                  onClick={() => {
                    trackFootfallEvent(Event.CLICKED, {
                      clickType: 'hub-menu',
                      clickMetadata: { section: Section.CommunitySearch },
                    });
                  }}
                >
                  <Avatar alt="Find a community" size="xsmall" src={`${config.cdn.bg}BrowseCommunities.svg`} />
                  {i18n.t('Find a community')}
                </a>
              </li>
            )}
            {followedCommunities.length > 3 && (
              <li>
                <a
                  className="sitebar-dropdown__link"
                  href="#"
                  onClick={event => {
                    event.stopPropagation();
                    this.setState({ showAllCommunities: !showAllCommunities });
                  }}
                >
                  {showAllCommunities ? `- ${i18n.t('view less')}` : `+ ${i18n.t('view all your communities')}`}
                </a>
              </li>
            )}
          </ul>
          <div className="divider">
            {i18n.t('Programs')}{' '}
            <Badge content={i18n.t('NEW')} type="new" />
          </div>
          {programs.length
            ? (
              <ul>
                {programs.map(({code, name}) => (
                  <li key={code}>
                    <a
                      href={`/programs/${code}`}
                      onClick={() => {
                        const element = name;
                        trackFootfallEvent(Event.CLICKED, { clickMetadata: {section: Section.Program, element}, clickType: 'hub-menu' });
                      }}
                    >
                      <Avatar alt={`${name} image`} size="xsmall" src={`${PROGRAM_URL}${code}.png`} />
                      {name}
                    </a>
                  </li>
                ))}
                {programs.length > 3 && (
                  <li>
                    <a
                      className="sitebar-dropdown__link"
                      onClick={event => {
                        event.stopPropagation();
                        this.setState({ showAllPrograms: !showAllPrograms });
                      }}
                    >
                      {showAllPrograms ? `- ${i18n.t('view less')}` : `+ ${i18n.t('view all your programs')}`}
                    </a>
                  </li>
                )}
              </ul>
            ) : <ProgramsEmptyState />
          }
        </SitebarDropdown>
      </Container>
    );
  }
}

const ProgramEmptyStateSubtitle = styled.div`
  ${text};
  padding: 15px;
`;

const ProgramEmptyStateText = styled.div`
  ${textLight};
  padding-bottom: 10px;
`;

const SuggestedProgramList = styled.ul`
  margin: 0;
`;

const SuggestedProgramLinkItem = styled.a`
  padding: 7.5px 0!important;
  &:hover {
    background: none;
  }
`;

const Container = styled.div`
  .hub-menu__browse-communities__link {
    color: ${({theme}) => theme.colorBlue} !important;
  }
`;

const HubMenuButton = styled(LinkButton)<{isActive: boolean}>`
  ${textLinkSecondary};
  font-family: ${({theme}) => theme.fontFamilyTitle};
  line-height: 49px;
  padding: 0 12px;
  display: flex;
  align-items: center;

  &:focus, &:hover, &:active {
    color: ${({theme}) => theme.colorBlack};
  }

  ${({isActive}) => isActive && css`
    color: ${({theme}) => theme.colorBlack};
  `};
`;

const Icon = styled.span`
  margin-right: 5px;
  font-size: ${({theme}) => theme.fontSizeM};
`;
